import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	sectionTitle: {
		id: 'fastshift.dc-instance-details.assessment-results.section-title',
		defaultMessage: 'Results',
		description: 'Heading for the Cloud Readiness assessment results section.',
	},
	sectionDescription: {
		id: 'fastshift.dc-instance-details.assessment-results.section-description',
		defaultMessage: 'Review the status of each check. Select a result for more details.',
		description: 'Instructions displayed above the Cloud Readiness assessment result list.',
	},
	statusFilter: {
		id: 'fastshift.dc-instance-details.assessment-results.status-filter',
		defaultMessage: 'Status',
		description: 'Label for the assessment result status filter.',
	},
	statusFilterMenu: {
		id: 'fastshift.dc-instance-details.assessment-results.status-filter-menu',
		defaultMessage: 'Filter results by status',
		description: 'Accessible label for the assessment result status filter menu.',
	},
	passedFilter: {
		id: 'fastshift.dc-instance-details.assessment-results.passed-filter',
		defaultMessage: 'Passed',
		description: 'Filter option that displays passed assessment results.',
	},
	needsAttentionFilter: {
		id: 'fastshift.dc-instance-details.assessment-results.needs-attention-filter',
		defaultMessage: 'Needs attention',
		description: 'Filter option that displays assessment results requiring attention.',
	},
	skippedFilter: {
		id: 'fastshift.dc-instance-details.assessment-results.skipped-filter',
		defaultMessage: 'Skipped',
		description: 'Filter option that displays skipped assessment results.',
	},
	clearFilters: {
		id: 'fastshift.dc-instance-details.assessment-results.clear-filters',
		defaultMessage: 'Clear filters',
		description: 'Button that clears the active assessment result filters.',
	},
	resultCount: {
		id: 'fastshift.dc-instance-details.assessment-results.result-count',
		defaultMessage:
			'Showing {visibleCount} of {totalCount} {totalCount, plural, one {check} other {checks}}',
		description: 'Count of visible Cloud Readiness assessment checks after filtering.',
	},
	passedStatus: {
		id: 'fastshift.dc-instance-details.assessment-results.passed-status',
		defaultMessage: 'Passed',
		description: 'Accessible status label for a low-risk assessment result.',
	},
	skippedStatus: {
		id: 'fastshift.dc-instance-details.assessment-results.skipped-status',
		defaultMessage: 'Skipped',
		description: 'Accessible status label for a skipped assessment result.',
	},
	unavailableStatus: {
		id: 'fastshift.dc-instance-details.assessment-results.unavailable-status',
		defaultMessage: 'Unavailable',
		description: 'Accessible status label when an assessment result has no risk status.',
	},
	needsAttentionStatus: {
		id: 'fastshift.dc-instance-details.assessment-results.needs-attention-status',
		defaultMessage: 'Needs attention',
		description: 'Accessible status label for a medium- or high-risk assessment result.',
	},
	resultStatus: {
		id: 'fastshift.dc-instance-details.assessment-results.result-status',
		defaultMessage: 'Status: {status}.',
		description: 'Accessible description for an assessment result without a recommendation.',
	},
	resultStatusWithRecommendation: {
		id: 'fastshift.dc-instance-details.assessment-results.result-status-with-recommendation',
		defaultMessage: 'Status: {status}. Recommendation available.',
		description: 'Accessible description for an assessment result with a recommendation.',
	},
	progressBarLabel: {
		id: 'fastshift.dc-instance-details.assessment-results.progress-bar-label',
		defaultMessage: '{dataPoint} usage',
		description: 'Accessible label for an assessment result guardrail progress bar.',
	},
	loadingResults: {
		id: 'fastshift.dc-instance-details.assessment-results.loading-results',
		defaultMessage: 'Loading assessment results',
		description: 'Accessible label for the assessment result loading indicator.',
	},
	emptyResults: {
		id: 'fastshift.dc-instance-details.assessment-results.empty-results',
		defaultMessage: 'No assessment results are available.',
		description: 'Message displayed when an assessment has no results.',
	},
	noMatchingResults: {
		id: 'fastshift.dc-instance-details.assessment-results.no-matching-results',
		defaultMessage: 'No results match this filter.',
		description: 'Message displayed when no assessment results match the selected filter.',
	},
});
